import { useNavigate } from "react-router-dom";
import { setNavigator } from "./utils/navigationService";
import { useEffect } from "react";
import { ROUTES } from "./routes/routePaths";
import { registerNativeHandlers } from "./platform/android/nativeReceiver";
import { initFCMManager } from "./utils/fcmManager";
import { initBranch } from "./utils/branchService";
import { initBranchTrafficManager } from "./utils/branchTrafficManager";
import AppRoutes from "./routes/appRoutes";
import MainLayout from "./layouts/MainLayout";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import "./App.scss";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
    registerNativeHandlers();
    void initFCMManager();
    void initBranch().catch(() => {});
    initBranchTrafficManager();

    const handlePageShow = (event) => {
      if (event.persisted) navigate(ROUTES.APP_INITIALIZER, { replace: true });
    };
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [navigate]);

  return (
    <ErrorBoundary>
      <MainLayout>
        <AppRoutes />
      </MainLayout>
    </ErrorBoundary>
  );
}

export default App;
